export const VOIP_PROVIDER = {
	TWILIO: 'Twilio',
	RINGOSTAT: 'Ringostat',
	CLOUD_TALK: 'CloudTalk',
	VONAGE: 'Vonage',
};

export const VOIP_PROVIDERS = Object.values(VOIP_PROVIDER);
